import { pixels } from '@asap-hub/react-components';
import { layoutContentStyles } from '../layout';
const {
  rem
} = pixels;
const components = {
  NavigationLink: {
    styles: {
      svg: {
        fill: 'currentColor'
      }
    }
  },
  Accordion: {
    containerStyles: {
      padding: 0
    },
    itemStyles: {
      margin: 0
    }
  },
  Pill: {
    styles: {
      fontSize: rem(14),
      padding: '4px 8px',
      lineHeight: rem(16),
      maxWidth: 'fit-content'
    }
  },
  TabLink: {
    styles: {},
    layoutStyles: {}
  },
  ExternalLink: {
    styles: {
      margin: 0
    }
  },
  EventPage: {
    containerStyles: layoutContentStyles
  },
  EditModal: {
    bodyStyles: {
      height: '100%',
      boxSizing: 'border-box',
      padding: 0
    },
    styles: {
      display: 'unset'
    }
  },
  ContentPage: {
    styles: {
      padding: 0
    }
  }
};
export default components;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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